export const environment = {
  production: true,
   // apiUrl: 'http://localhost:8097/',
  //  apiUrl1: 'http://localhost:8086/api/',
  apiUrl: 'https://apimentoring.diu.edu.bd/',
  cdnLocMentoring: 'http://cdn.diu.edu.bd/mentoring',

};
